/* eslint-disable @typescript-eslint/naming-convention */

import { formatDate } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DownloaderService } from '../../shared/download/downloader.service';
import { JsonHttpService } from '../../shared/http/json-http.service';
import { PartnerExportOptions } from '../models/partner-export-options';

@Injectable({
    providedIn: 'root'
})
export class PartnerExportService {

    constructor(
        private http: JsonHttpService,
        private downloaderService: DownloaderService) {
    }

    async exportPartners(partnerIds: number[], exportOptions: PartnerExportOptions): Promise<any> {
        const filename = `PartnerExport_${formatDate(new Date(), 'yyyyMMdd_HHmmss', 'en')}`;
        const options = { params: new HttpParams().set('filename', filename) };
        const partnerExportOptions = {
            ExportContacts: exportOptions.exportContacts,
            ExportConfigurationKeys: exportOptions.exportConfigurationKeys,
            ExportTags: exportOptions.exportTags,
            ExportProxyRelations: exportOptions.exportProxyRelations,
            ExportX12EdifactConfiguration: exportOptions.exportX12EdifactConfig,
            ExportTransportOutConfiguration: exportOptions.exportTransportOutConfig,
            PartnerIds: partnerIds,
        };

        const token = await this.http.post('/api/partners/export/export', partnerExportOptions, options, true).toPromise();

        return this.downloaderService.downloadFile(token);
    }
}
